import { useCallback, useEffect } from 'react'

import { useEnsureConversation } from './useEnsureConversation'
import { MessengerThread } from '../types'

export const useEnsureConversationForThread = (thread: MessengerThread | null, threadsLoaded: boolean) => {
  const ensureConversation = useEnsureConversation()

  // Before threads load, a null conversationId only means "not loaded yet", so creating then duplicates.
  useEffect(() => {
    if (threadsLoaded && thread && !thread.conversationId) {
      ensureConversation(thread)
    }
  }, [ensureConversation, thread, threadsLoaded])

  return useCallback(() => ensureConversation(thread), [ensureConversation, thread])
}
